import Vue from 'vue'
import VueRouter from 'vue-router'
import index from '../views/newIndex'
import { resolveSeo, setSeo, PC_PATH, MOBILE_PATH, toPcName, isMobileName } from '@/utils/seo'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    component: index,
    meta: {
      title:'首页'
    }
  },
  {
    path: '/phone',
    name: 'phone',
    component: () => import('../views/phone/index.vue'),
    meta: {
      title:'手机首页'
    }
  },
  {
    path: '/brandConceptPhone',
    name: 'brandConceptPhone',
    component: () => import('../views/phone/brandConceptPhone.vue'),
    meta: {
      title:'品牌理念'
    }
  },
  {
    path: '/brandConcept',
    name: 'brandConcept',
    component: () => import('../views/brandConcept.vue'),
    meta: {
      title:'品牌理念'
    }
  },
  {
    path: '/intelligentGuidanceIndex',
    name: 'intelligentGuidance',
    component: () => import('../views/intelligentGuidance.vue'),
    meta: {
      title: '智慧导诊'
    }
  },
  {
    path: '/intelligentGuidanceIndexPhone',
    name: 'intelligentGuidancePhone',
    component: () => import('../views/phone/intelligentGuidancePhone.vue'),
    meta: {
      title: '智慧导诊'
    }
  },
  {
    path: '/enterpriseInformation',
    name: 'enterpriseInformation',
    component: () => import('../views/enterpriseInformation.vue'),
    meta: {
      title:'企业资讯'
    }
  },
  {
    path: '/enterpriseInformationPhone',
    name: 'enterpriseInformationPhone',
    component: () => import('../views/phone/enterpriseInformationPhone.vue'),
    meta: {
      title:'企业资讯'
    }
  },
  {
    path: '/enterpriseInformationInfo',
    name: 'enterpriseInformationInfo',
    component: () => import('../views/enterpriseInformationInfo.vue'),
    meta: {
      title:'企业资讯'
    }
  },
  {
    path: '/enterpriseInformationInfoPhone',
    name: 'enterpriseInformationInfoPhone',
    component: () => import('../views/phone/enterpriseInformationInfoPhone.vue'),
    meta: {
      title:'企业资讯'
    }
  },
  {
    path: '/businessCooperation',
    name: 'businessCooperation',
    component: () => import('../views/businessCooperation.vue'),
    meta: {
      title:'商务合作'
    }
  },
  {
    path: '/businessCooperationPhone',
    name: 'businessCooperationPhone',
    component: () => import('../views/phone/businessCooperationPhone.vue'),
    meta: {
      title:'商务合作'
    }
  },
  {
    path: '/coreProduct',
    name: 'coreProduct',
    component: () => import('../views/coreProduct.vue'),
    meta: {
      title:'核心产品'
    }
  },
  {
    path: '/coreProductPhone',
    name: 'coreProductPhone',
    component: () => import('../views/phone/coreProductPhone.vue'),
    meta: {
      title:'核心产品'
    }
  },
  {
    path: '/coreProductInfo',
    name: 'coreProductInfo',
    component: () => import('../views/coreProductInfo.vue'),
    meta: {
      title:'核心产品'
    }
  },
  {
    path: '/coreProductInfoPhone',
    name: 'coreProductInfoPhone',
    component: () => import('../views/phone/coreProductInfoPhone.vue'),
    meta: {
      title:'核心产品'
    }
  },
  {
    path: '/talentRecruitment',
    name: 'talentRecruitment',
    component: () => import('../views/talentRecruitment.vue'),
    meta: {
      title:'人才招聘'
    }
  },
  {
    path: '/talentRecruitmentPhone',
    name: 'talentRecruitmentPhone',
    component: () => import('../views/phone/talentRecruitmentPhone.vue'),
    meta: {
      title:'人才招聘'
    }
  },
  {
    path: '/recruitInfoPhone',
    name: 'recruitInfoPhone',
    component: () => import('../views/phone/recruitInfoPhone.vue'),
    meta: {
      title:'人才招聘'
    }
  },
  {
    path: '/recruitInfo',
    name: 'recruitInfo',
    component: () => import('../views/recruitInfo.vue'),
    meta: {
      title:'人才招聘'
    }
  },
  {
    path: '/contactUsPhone',
    name: 'contactUsPhone',
    component: () => import('../views/phone/contactUsPhone.vue'),
    meta: {
      title:'联系我们'
    }
  },
  {
    path: '/contactUs',
    name: 'contactUs',
    component: () => import('../views/contactUs.vue'),
    meta: {
      title:'联系我们'
    }
  },
]
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

// SEO：路由切换时写入该页面的 title / keywords / description / canonical
// 说明：
// 1. resolveSeo 是异步的（详情页需要按需加载列表数据取真实标题），所以必须 await 后再写。
//    此前把标题写在详情组件的 created 里是无效的——守卫在组件挂载后会再写一次，会把组件覆盖掉。
// 2. 移动适配（百度「跳转适配」规范）：
//    PC 页加 rel="alternate" 指向手机版；手机端页面的 canonical 指回 PC 页。
router.afterEach((to) => {
  Vue.nextTick(async () => {
    const name = to.name || 'index'
    const pcName = toPcName(name)
    const seo = await resolveSeo(to)

    // 详情页保留 ?id=，让每条产品/资讯各自成为可收录的独立网址；
    // 其余查询参数（如列表页的筛选参数）丢弃，避免重复收录。
    const isDetail = pcName === 'coreProductInfo' ||
      pcName === 'enterpriseInformationInfo' || pcName === 'recruitInfo'
    const idQuery = isDetail && to.query.id ? `?id=${encodeURIComponent(to.query.id)}` : ''
    const pcPath = (PC_PATH[pcName] || '/') + idQuery
    const mobilePath = (MOBILE_PATH[pcName] || '/') + idQuery

    setSeo({
      title: seo.title,
      keywords: seo.keywords,
      description: seo.description,
      path: to.path,
      // 手机端页面 canonical 指回 PC 页；PC 页 canonical 指自己 + 标注手机版
      canonicalPath: pcPath,
      alternatePath: isMobileName(name) ? '' : mobilePath,
    })
  })
})

export default router
